module.exports = __webpack_public_path__ + "7c47d09806ab5233479304391a9442f0.pdf";